import { render, staticRenderFns } from "./SignatureBackground.vue?vue&type=template&id=60175b4d"
import script from "./SignatureBackground.vue?vue&type=script&lang=js"
export * from "./SignatureBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports